(function() {

    /**
     * @type Basket
     */
    var Basket = (/** @constructor */ function() {

        /** @type {Object} параметры */
        var opt = {
            scrollDuration : 250,
            realyProdCountText : 'В наличии CNT шт.'
        };



        /** @type {Object} данные объекта */
        var o = {
            summ : 0,
            shipment : 0,
            discount : 0,
            free: 0,
            total : 0
        };

        function initBasketTable() {
            var rowsHash = {};
            var $table = o.$table;
            var $rows = $table.find('tbody tr'),
            $total = $table.find('.total');
            for (var i = 0; i < $rows.length; i++) {
                if(!$rows.eq(i).hasClass('gift-prod')){
                    rowsHash[$rows.eq(i).data('productId')] = i;
                }
            }

            var $countInputs = $table.find('.count input')
                .inputArrowCounter()
                .change(countChangeHandler);
                //maxValue : 5

            $table.find('.del').click(deleteHandler);

            //initGiftItem($table.find(".gift-prod"));

            var $gwInput = $table.find('.gift-wrap input').change(function() {
                Order.setGiftWrapState(this.checked, function(data) {
                    $gwInput.prop('checked', (data.state) ? true : false);
                    updateHandler(data);
                });
            });

            $table.find(".b-spoiler").each(function(){
                var d = $(document.createElement("a"))
                            .addClass("b-spl-trigger")
                            .attr("href","#")
                            .text("Подробнее")
                            .insertAfter($(this))
                            .click(function(){ triggerSpoiler(this); return false; });
                d.get(0).__spl = this;
                d.get(0).__spl.shown = true;
                // d.width($(this).width());
                triggerSpoiler(d.get(0));
            });

            function triggerSpoiler(el){
                if(el.__spl.shown){
                    el.innerHTML = "<span>Подробнее</span>";
                    $(el.__spl).stop().slideUp(300,function(){ el.__spl.shown = false;  });
                }else{
                    el.innerHTML = "<span>Скрыть</span>";
                    $(el.__spl).stop().slideDown(300,function(){ el.__spl.shown = true;  });
                }
            }

            function countChangeHandler() {
                var $row = $(this).parents('tr').eq(0),
                    $summ = $row.find('.summ'),
                    id = $row.data('productId'),
                    count = this.value;
                Order.update(id, count, updateHandler);
            }

            function deleteHandler() {
                if(window.confirm("Вы действительно хотите убрать товар из корзины?")){
                    var $row = $(this).parents('tr').eq(0),
                        id = $row.data('productId');
                    Order.update(id, 0, updateHandler);
                }
            }

            function updateHandler(data) {
                var id = (data.item) ? data.item.hash : data.deleted;
                if (id) {
                    var $row = $rows.eq(rowsHash[id]);
                    if (data.item) {
                        $row.find(".count input").val(data.item.count);
                        var $summ = $row.find('.summ');

                        $summ.html((data.item.price * data.item.count).toPrice());

                    } else if (data.deleted) {
						$row.fadeOut(500, function() {
	                        $row.remove();
	                        if (data.count == 0) {
	                            emptyBasket();
	                        }
						});
                    }

                    if((!data.gift)&&($table.find(".gift-prod").length)){
                        $table.find(".gift-prod").remove();
                    }

                }
                o.summ = parseFloat(data.summ);
                o.discount = parseFloat(data.discount);
                $total.html(o.summ.toPrice());

                updateTotal();
            }
        }

        function updateTotal() {
            if((o.free_summ>0)&&(o.summ>=o.free_summ)){
                o.shipment = 0;
            }
            o.total = o.summ + o.shipment - o.discount;
        }

        function emptyBasket() {
            window.location.reload();
        }

        return {
            /**
             * @memberOf Basket
             * @returns
             */
            init : function(options) {
                $.extend(opt, options);
                o.$table = $(opt.tableSelector);

                if (o.$table.length) {
                    initBasketTable();
                }
            }
        };
    })();
    Order.Basket = Basket;

    /* Объект для работы с заказом */
    var Checkout = function(){
        var step = 1;

        var cobject = {};

        var $dom, $prevBtn, $nextBtn = $();

        function stepHandler(data) {
            if (cobject.repsonseHandler) {
                Checkout.enableNext();
                cobject.repsonseHandler(data);
            } else {
                if (data.ok) {
                    var href = window.location.href;
                    href = href.replace(/\?.*$/,"");
                    var str = '';
                    while(str.length<16){
                        str+=Math.round(Math.random()*10).toString();
                    }
                    window.location.assign(href+"?s="+str);
                } else if (data.error) {
                    if (cobject.errorHandler) {
                        Checkout.enableNext();
                        cobject.errorHandler(data);
                    }
                }
            }
        }

        function nextHandler() {
            var $this = $(this);
            if (!$this.hasClass('btn-disabled')) {
                if (cobject.nextAction) {
                    var params = cobject.nextAction();
                    if (params) {
                        Checkout.disableNext();
                        Checkout.getJSON(params, stepHandler);
                    }
                } else {
                    Checkout.disableNext();
                    go(true);
                }
            }
            return false;
        }

        function prevHandler() {
            var $this = $(this);
            if (!$this.hasClass('btn-disabled')) {
                if (cobject.prevAction) {
                    var params = cobject.prevAction();
                    if (params) {
                        Checkout.disablePrev();
                        Checkout.getJSON(params, stepHandler);
                    }
                }else{
                    var pos = $this.offset();
                    Checkout.disablePrev();
                    go(false);
                }
            }
            return false;
        }

        function go(next) {
            Checkout.getJSON({
                _do : (next) ? 'order_next' : 'order_prev'
            },
                stepHandler
            );
        }

        return {
            init: function(iface){
                $nextBtn = $("#next-btn, #next-btn-data").click(nextHandler);
                $prevBtn = $("#prev-btn").click(prevHandler);

                switch (iface) {
                    case 'basket' :
                        cobject = Checkout.Basket();
                    break;
                    case 'personal' :
//                        $('[name="inn"]').inputmask("9{1,30}");
//                        $('[name="kpp"]').inputmask("9{1,30}");
//                       $('[name="phone"]').inputmask("phone");
//                        $('[name="email"]').inputmask("email");
                        cobject = Checkout.Personal();
                    break;
                    case 'check' :
                        cobject = Checkout.Check();
                    break;
                    case 'one_click' :
                        cobject = Checkout.Basket();
                        cobject = Checkout.OneClick();
                    break;
                }
            },
            disableNext : function() {
                $nextBtn.addClass('btn-disabled');
                $nextBtn.attr("disabled","disabled");
            },
            enableNext : function() {
                $nextBtn.removeClass('btn-disabled');
                $nextBtn.removeAttr("disabled");
            },

            disablePrev : function() {
                $prevBtn.addClass('btn-disabled');
                $prevBtn.attr("disabled","disabled");
            },
            enablePrev : function() {
                $prevBtn.removeClass('btn-disabled');
                $prevBtn.removeAttr("disabled");
            },
            hideNext : function() {
                $nextBtn.hide()
            },
            showNext : function() {
                $nextBtn.show()
            },
            hidePrev : function() {
                $prevBtn.hide()
            },
            showPrev : function() {
                $prevBtn.show()
            },
            renameNext: function(text){
                $nextBtn.html(text);
            },
            renamePrev: function(text){
                $prevBtn.html(text);
            },
            DOM: function(){
                return $dom
            },
            getJSON : function(data, handler) {
                /* Пробрасываем в глобальный объект вместо использования локального */
                var action = data._do;
                delete data._do;
                Order.getJSON(action, data, handler);

                /*if (Talon.SESS_ID)
                    data['SESS_ID'] = Talon.SESS_ID;
                    data["ch_code"] = hash;
                    data["lpu_id"] = lpu_id;
                    $.post("/oa/", data, handler, 'json');*/
            },
            showError: function(error){
            },
        }
    }();

    /**
      * Класс для работы с корзиной
      */
    Checkout.Basket = function(){

        /** @type {Object} параметры */
        var opt = {
            scrollDuration : 300,
            realyProdCountText : 'В наличии CNT шт.'
        };



        /** @type {Object} данные объекта */
        var o = {
            summ : 0,
            shipment : 0,
            discount : 0,
            free: 0,
            total : 0
        };

        o.$table = $("#basket-checkout");

        Checkout.renameNext("Оформить заказ");
        Checkout.hidePrev();

        if (o.$table.length) {
            initBasketTable();
        }

        function initBasketTable() {
            var rowsHash = {};
            var $table = o.$table;
            var $rows = $table.find('tbody tr'),
            $total = $table.find('.total');
            for (var i = 0; i < $rows.length; i++) {
                if(!$rows.eq(i).hasClass('gift-prod')){
                    rowsHash[$rows.eq(i).data('productId')] = i;
                }
            }

            var $countInputs = $table.find('.count input')
                .inputArrowCounter()
                .change(countChangeHandler);

            $table.find('.del').click(deleteHandler);

			$clearBtn = $("#clear-btn").click(clearHandler);

            $table.find(".b-spoiler").each(function(){
                var d = $(document.createElement("a"))
                            .addClass("b-spl-trigger")
                            .attr("href","#")
                            .text("Подробнее")
                            .insertAfter($(this))
                            .click(function(){ triggerSpoiler(this); return false; });
                d.get(0).__spl = this;
                d.get(0).__spl.shown = true;
                triggerSpoiler(d.get(0));
            });

            function clearHandler() {
                $table.fadeOut().remove();
                Checkout.getJSON({ '_do': 'clear_basket', 'summ': '0' },emptyBasket);
                return false;
            }

            function triggerSpoiler(el){
                if(el.__spl.shown){
                    el.innerHTML = "<span>Подробнее</span>";
                    $(el.__spl).stop().slideUp(opt.scrollDuration,function(){ el.__spl.shown = false;  });
                }else{
                    el.innerHTML = "<span>Скрыть</span>";
                    $(el.__spl).stop().slideDown(opt.scrollDuration,function(){ el.__spl.shown = true;  });
                }
            }

            function countChangeHandler() {
                var $row = $(this).parents('tr').eq(0),
                    $summ = $row.find('.summ'),
                    id = $row.data('productId'),
                    count = this.value;
                Order.update(id, count, updateHandler);
            }

            function deleteHandler() {
                if(window.confirm("Вы действительно хотите убрать товар из корзины?")){
                    var $row = $(this).parents('tr').eq(0),
                        id = $row.data('productId');
                    Order.update(id, 0, updateHandler);
                }
            }

            function updateHandler(data) {
                var id = (data.item) ? data.item.id : data.deleted;
                if (id) {
                    var $row = $rows.eq(rowsHash[id]);
                    if (data.item) {
                        $row.find(".count input").val(data.item.count);
                        var $summ = $row.find('.summ');

                        $summ.html((data.item.price * data.item.count).toPrice());

                    } else if (data.deleted) {
						$row.fadeOut(500, function() {
	                        $row.remove();
	                        if (data.count == 0) {
	                            emptyBasket();
	                        }
						});
                    }

                    if((!data.gift)&&($table.find(".gift-prod").length)){
                        $table.find(".gift-prod").remove();
                    }

                }
                o.summ = parseFloat(data.summ);
                o.discount = parseFloat(data.discount);
                $total.html(o.summ.toPrice());

                updateTotal();
            }
        }

        function updateTotal() {
            if((o.free_summ>0)&&(o.summ>=o.free_summ)){
                o.shipment = 0;
            }
            o.total = o.summ + o.shipment - o.discount;
        }

        function emptyBasket() {
            window.location.reload();
        }

        return {
            /*
            nextAction : function() {
                //return prepareForm();
            },
            errorHandler: function(data){
                //Talon.OrderNew.showError(data.error_text);
            }*/
        }
    }


    /**
      * Класс для работы с персональными данными
      */
    Checkout.Personal = function(){

        var adds = {};

        var
            _cache = {};

/*
	    $wrap.find(".placeholder").each(function() {
	        var $input = $("input[type='text'], textarea", this);
	        if ($input.length) {
	            var text = $(".label", this).hide().text();
//	            $input.attr({placeholder: text});
	        }
	    });
*/
        function prepareForm(){

            var $wrap = $('.order-form .tab-pane.active');
            var params = {
                '_do' : 'submit_personal'
            };
            var errorFlag = false;

            $wrap.find('.form-group').removeClass('has-error');
            var $fields = $wrap.find('.form-group input, .form-group textarea');
            var right_email = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            var right_date = /^\d\d\.\d\d\.\d\d\d\d$/;

            for (var i = 0; i < $fields.length; i++) {
                var $f = $fields.eq(i), $p = $f.parents(".form-group");
                var name = $f.attr('name');
                var check = $f.prop('checked');
                var val = $f.val().trim();

                if (val) {
					if ($f.attr('type')=='radio' || $f.attr('type')=='checkbox') {
						if ($f.attr('checked')) { params[name] = val; }
					} else {
	                    params[name] = val;
					}
                }

				if (($p.hasClass('required')) && ($f.attr('type')=='radio' || $f.attr('type')=='checkbox')) {
					if (!params[name] && $p.css('display') != 'none') {
	                    $p.addClass('has-error');
					} else {
	                    $p.removeClass('has-error');
					}
				}

                if (($p.hasClass('required')) && (val == '') && $p.css('display') != 'none') {
					//if ($p.parents('.address').css('display') == 'none') continue;
                    $p.addClass('has-error');
                    errorFlag = true;
                }
                if((name == 'email') && ((val == '') || (!(right_email.test(val))))){
                    $p.addClass('has-error');
                    errorFlag = true;
                }
                if((name == 'agree') && (check == '')){
                    $p.addClass('has-error');
                    errorFlag = true;
                }
            }

	        var $fields = $wrap.find('.form-group.has-error input[type=radio]');
			if ($fields.length>0) { errorFlag = true; }

            if (!errorFlag) {
                for(var key in adds){
                    params[key] = 1;
                }
                return params;
            }
            return false;
        }

        return {
            nextAction : function(){
                return prepareForm();
            }
        }
    }

    /**
      * Класс для работы в один клик
      */
    Checkout.OneClick = function(){

        var adds = {};

        var
            _cache = {};

/*
	    $wrap.find(".placeholder").each(function() {
	        var $input = $("input[type='text'], textarea", this);
	        if ($input.length) {
	            var text = $(".label", this).hide().text();
//	            $input.attr({placeholder: text});
	        }
	    });
*/
        function prepareForm(){

            var $wrap = $('#modal .order-form .tab-pane.active');
            var params = {
                '_do' : 'submit_one_click'
            };
            var errorFlag = false;

            $wrap.find('.form-group').removeClass('has-error');
            var $fields = $wrap.find('.form-group input, .form-group textarea');
            var right_email = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            var right_date = /^\d\d\.\d\d\.\d\d\d\d$/;

            for (var i = 0; i < $fields.length; i++) {
                var $f = $fields.eq(i), $p = $f.parents(".form-group");
                var name = $f.attr('name');
                var check = $f.prop('checked');
                var val = $f.val().trim();

                if (val) {
					if ($f.attr('type')=='radio' || $f.attr('type')=='checkbox') {
						if ($f.attr('checked')) { params[name] = val; }
					} else {
	                    params[name] = val;
					}
                }

				if (($p.hasClass('required')) && ($f.attr('type')=='radio' || $f.attr('type')=='checkbox')) {
					if (!params[name] && $p.css('display') != 'none') {
	                    $p.addClass('has-error');
					} else {
	                    $p.removeClass('has-error');
					}
				}

                if (($p.hasClass('required')) && (val == '') && $p.css('display') != 'none') {
					//if ($p.parents('.address').css('display') == 'none') continue;
                    $p.addClass('has-error');
                    errorFlag = true;
                }
                if((name == 'email') && ((val == '') || (!(right_email.test(val))))){
                    $p.addClass('has-error');
                    errorFlag = true;
                }
                if((name == 'agree') && (check == '')){
                    $p.addClass('has-error');
                    errorFlag = true;
                }
            }

	        var $fields = $wrap.find('.form-group.has-error input[type=radio]');
			    if ($fields.length>0) { errorFlag = true; }

            if (!errorFlag) {
                for(var key in adds){
                    params[key] = 1;
                }
                $.fancybox.showLoading();
                Checkout.getJSON(params, answer);
          			return false;
                //return params;
            }
            return false;
            function answer(data){
                var $wrap = $("#basket-checkout");
                if(data.order_id){
                    $.fancybox.hideLoading();
                    Checkout.hideNext();
                    $wrap.fadeOut(function(){
                        $wrap.html(data.content).fadeIn(300);
                    })
            				Order.BasketBlock.update(0,0);
                }
            }
        }

        return {
            nextAction : function(){
                Proj.yaReachGoal('39512360', 'form_1_cilck_send');
                return prepareForm();
            }
        }
    }

    /**
      * Класс для работы с финальной проверкой
      */
    Checkout.Check = function(){

        var $wrap = $("#basket-checkout");
        Checkout.hideNext();
        var send_btn = $("#send-btn").click(function(){
            $.fancybox.showLoading();
            Checkout.hidePrev();
            send_btn.hide();
            var yaClientID = yaCounter39512360.getClientID();
            Checkout.getJSON({ _do: "submit_order", yaClientID: yaClientID }, answer);
      			return false;
        });

        function answer(data){
            if(data.order_id){
                var products = [];
                $.each(data.items, function(i){
                    products.push({
                        "id": data.items[i].id,
                        "name" : data.items[i].name,
                        "price" : data.items[i].price,
                        "quantity": data.items[i].count
                    });
                });
                dataLayer.push({
                    "ecommerce": {
                        "purchase": {
                            "actionField": {
                                "id" : data.order_id,
                                "goal_id" : 32673150
                            },
                            "products": products
                        }
                    }
                });
                $.fancybox.hideLoading();
                // Checkout.hideNext();
                $wrap.fadeOut(function(){
                    $wrap.html(data.content).fadeIn(300);
                })
				Order.BasketBlock.update(0,0);
            }
        }

        return {

        }
    }

    Order.Checkout = Checkout;

})();